export default __webpack_public_path__ + "static/media/gsmlogo.0749c0e4.png";